<template>
  <Catalog>
    <slot />
  </Catalog>
</template>

<script lang="ts" setup>
import { Catalog } from '@crearis/ui'
</script>
